export const endpoints = {
  START_INTERVIEW: "/gpraInterview/startInterview",
  INTERVIEW_STATUS: "/gpraInterview/statusInterview",
  GPRA_RECORD_HISTORY: "/gpraRecord/getHistory",
  CANCEL_INTERVIEW: "/gpraInterview/cancelInterview",
  FINISH_INTERVIEW: "/gpraInterview/finishInterview",
  GET_INTERVIEW_TYPES: "/gpraInterview/interviewType",
  GET_PDF: "/gpraReports/getPdf",
  SAVE_BH_DATA: "/gpraBh/saveGpraABh",
  GET_BH_DATA: "/gpraBh/getGpraABh",
  SAVE_SERVICES1_DATA: "/gpraServices/saveGpraBServices1",
  SAVE_SERVICES2_DATA: "/gpraServices/saveGpraBServices2",
  SAVE_SERVICES3_DATA: "/gpraServices/saveGpraBServices3",
  SAVE_SERVICES4_DATA: "/gpraServices/saveGpraBServices4",
  GET_PLANNED_SERVICES_DATA: "/gpraServices/getGpraBServices",
  SAVE_DEMOGRAPHICS_DATA: "/gpraDemographics/saveGpraADemographics",
  GET_DEMOGRAPHICS_DATA: "/gpraDemographics/getGpraADemographics",
  SAVE_MILITARY_DATA: "/gpraMilitary/saveGpraAMilitary",
  GET_MILITARY_DATA: "/gpraMilitary/getGpraAMilitary",
  SAVE_SUBSTANCE_USE_DATA: "/gpraSubstanceUse/saveGpraBSubstanceUse",
  GET_SUBSTANCE_USE_DATA: "/gpraSubstanceUse/getGpraBSubstanceUse",
  SAVE_FAMILY_DATA: "/gpraFamily/saveGpraCFamily",
  GET_FAMILY_DATA: "/gpraFamily/getGpraCFamily",
  SAVE_EDUCATION_DATA: "/gpraEducation/saveGpraDEducation",
  GET_EDUCATION_DATA: "/gpraEducation/getGpraDEducation",
  SAVE_LEGAL_DATA: "/gpraLegal/saveGpraELegal",
  GET_LEGAL_DATA: "/gpraLegal/getGpraELegal",
  SAVE_MENTAL_DATA: "/gpraMental/saveGpraFMental",
  GET_MENTAL_DATA: "/gpraMental/getGpraFMental",
  SAVE_SOCIAL_DATA: "/gpraSocial/saveGpraGSocial",
  GET_SOCIAL_DATA: "/gpraSocial/getGpraGSocial",
  SAVE_PROGRAM_QUESTIONS_DATA: "/gpraProgram/saveGpraHProgram",
  GET_PROGRAM_QUESTIONS_DATA: "/gpraProgram/getGpraHProgram",
  SAVE_FOLLOWUP_DATA: "/gpraFollowUp/saveGpraIFollowUp",
  GET_FOLLOWUP_DATA: "/gpraFollowUp/getGpraIFollowUp",
  SAVE_DISCHARGE_DATA: "/gpraDischarge/saveGpraJDischarge",
  GET_DISCHARGE_DATA: "/gpraDischarge/getGpraJDischarge",
  SAVE_SERVICESRECEIVED1_DATA:
    "/gpraServicesReceived/saveGpraKServicesReceived1",
  SAVE_SERVICESRECEIVED2_DATA:
    "/gpraServicesReceived/saveGpraKServicesReceived2",
  SAVE_SERVICESRECEIVED3_DATA:
    "/gpraServicesReceived/saveGpraKServicesReceived3",
  SAVE_SERVICESRECEIVED4_DATA:
    "/gpraServicesReceived/saveGpraKServicesReceived4",
  SAVE_SERVICESRECEIVED5_DATA:
    "/gpraServicesReceived/saveGpraKServicesReceived5",
  GET_SERVICESRECEIVED_DATA: "/gpraServicesReceived/getGpraKServicesReceived",
  GET_SERVICE_TOKEN: "/gpraAuth/GetTokenWithApiKey",
  GET_CUSTOMIZATIONS: "/gpraCustomization/getGpraCustomization",
  SAVE_CUSTOMIZATIONS: "/gpraCustomization/saveGpraCustomization",
  GET_ADDITIONAL_QUESTIONS:
    "/gpraAdditionalQuestions/getGpraAdditionalQuestions",
  GET_SECTIONS_ORDERS: "/gpraAdditionalQuestions/getGpraSectionOrders",
  CHECK_ADDITIONAL_STATUS:
    "/gpraAdditionalQuestions/checkAdditionalQuestionsSaveStatus",
  SAVE_ADDITIONAL_QUESTIONS:
    "/gpraAdditionalQuestions/saveGpraAdditionalQuestion",
  DELETE_ADDITIONAL_QUESTIONS:
    "/gpraAdditionalQuestions/deleteGpraAdditionalQuestion",
  GET_DAYS_RESTRICTION: "/gpraRecord/getDaysRestriction",
  CREATE_GPRA_RECORD: "/gpraRecord/createGpraRecord",
  DELETE_GPRA_RECORD: "/gpraRecord/removeGpraRecord",
}
